import $$ from 'cmn-utils'

const baseUrl = "/api/device/product/action/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
}